module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a318b0c2bc41661e56b5dbb614ccd0f5.png";